import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Alert,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ReactComponent as LoginIcon } from "./assets/User-Podcast--Streamline-Plump.svg";
import { ReactComponent as JoinIcon } from "./assets/User-Switch-Account--Streamline-Plump.svg";
import { Link } from "react-router-dom";
import { messages } from "./config/messages";
import { keycloak } from "./config/auth";
import { BASENAME } from "./config/settings";

export default function StartPage() {
  return (
    <Container maxWidth="lg" sx={{ pt: 10, pb: 10 }}>
      <Box sx={{ flexGrow: 1 }}>
        {/* <div style={{margin: "1em"}}>
          <Alert severity="info">{messages.updateBannerText}</Alert>
        </div> */}
        <Grid container spacing={2} sx={{ justifyContent: "center" }}>
          <Grid size={6} style={{ display: "flex" }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column", // Make it vertical
                justifyContent: "space-between", // Push CardActions down
                height: "100%",
                borderRadius: 4,
                boxShadow: 3,
                transition: "0.3s",
                "&:hover": {
                  boxShadow: 6,
                  transform: "scale(1.02)",
                  backgroundColor: "#eef2f6",
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1, color: "#213270" }}>
                <JoinIcon
                  style={{
                    width: "10%",
                    paddingTop: "0.5em",
                    paddingBottom: "1em",
                    marginRight: "2em",
                  }}
                />
                <Typography variant="h4" gutterBottom>
                  {messages.startPageApplyCard}
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  dangerouslySetInnerHTML={{
                    __html: messages.startPageApplyLongText,
                  }}
                />
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to="/participant-form"
                >
                  {messages.startPageApplyButton}
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid size={6} style={{ display: "flex" }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column", // Make it vertical
                justifyContent: "space-between", // Push CardActions down
                height: "100%",
                borderRadius: 4,
                boxShadow: 3,
                transition: "0.3s",
                "&:hover": {
                  boxShadow: 6,
                  transform: "scale(1.02)",
                  backgroundColor: "#eef2f6",
                },
              }}
            >
              <CardContent sx={{ flexGrow: 1, color: "#213270" }}>
                <LoginIcon
                  style={{
                    width: "10%",
                    paddingTop: "1em",
                    paddingBottom: "0.5em",
                    marginRight: "2em",
                  }}
                />
                <Typography variant="h4" gutterBottom>
                  {messages.startPageLoginCard}
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  dangerouslySetInnerHTML={{
                    __html: messages.startPageLoginLongText,
                  }}
                />
              </CardContent>
              <CardActions>
                <div
                  style={{ display: "flex", gap: "1em", flexWrap: "nowrap" }}
                >
                  <div>
                    <Button
                      variant="contained"
                      onClick={() => {
                        keycloak.login({
                          redirectUri:
                            window.location.origin + BASENAME + "/management", // Specify the redirect URI
                        });
                      }}
                    >
                      {messages.startPageLoginButton}
                    </Button>
                  </div>
                </div>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
